import React, { Component } from 'react';

class CurrencyValue extends Component {

    
    state = { 
        value : this.props.value,
        currency : this.props.currency,
        id : this.props.id,
        icon : <div className="icon"></div>
     }

    componentDidUpdate(prevProps) {
  
    if (this.props.value !== prevProps.value) 
    {
        const tdid = this.props.id;
        var icon = this.state.icon;

        if(this.props.value < prevProps.value)
        {
            var tdidel = document.getElementById(tdid);
            if(tdidel !== null)
                tdidel.style.color = "red";
            icon = <div className="icon"><div className="arrow down"></div></div>;
            animateArrow(true,this.state.id);
        }
        else if(this.props.value > prevProps.value)
        {
            var tdidel = document.getElementById(tdid);
            if(tdidel !== null)
                tdidel.style.color = "green";
            icon = <div className="icon"><div className="arrow up"></div></div>;
            animateArrow(false,this.state.id);
        }

        setTimeout( function(){
            const item = document.getElementById(tdid);
            if (item != null)
                item.style.color = "white";
        },1000);

        this.setState({value : this.props.value, icon : icon});

    }   
    }

    render() { 
        return <td id={this.state.id}>{this.state.icon}<div className="currencyValue">{this.state.value} {this.state.currency}</div></td>;
    }

}

function animateArrow(isUp, id){


    const $arrowVis = document.querySelector('#' + id + '.arrow');
    if($arrowVis != null)
        $arrowVis.style.visibility = 'hidden';


    setTimeout(function () {
        var road = [{top: '35px'}, {top: '25px'}]
        if(isUp)
            road =[{top: '15px'}, {top: '25px'}]

        const $arrow = document.querySelector('#' + id + ' .arrow');
        if($arrow != null){
            $arrow.style.visibility = 'visible';
            $arrow.animate(road ,{
                duration: 700
                });
        }
    }, 200);
}
 
export default CurrencyValue;